import React from 'react'
import styles from '../componentsStyles/Stacks.module.css';

const StacksContent = () => {
  return (
    <div className={styles.StacksContent}>
        <div className={styles.stackIntro}>
            <p> This page is directed to inform some of the usual packages that i use in my projects</p>
            <p>
            This section does not mention all the tools used in the projects, depending on the final expectation of the project i will use some other packages, but among all cases these technologies are more common to appear.
            </p>
        </div>

            <div className={styles.stackInfo} id='stacks-mern'>
                <h3> MERN stack</h3>
                <p>
                    This is the most usual set of technologies used on react apps.
                </p>
            </div>

            <div className={styles.stackSection} id ='stacks-mern-db'>
                <label> Database</label>
                <p>
                The main way to persist customer data connected to the website.

                </p>
                <p>
                Mongo db is the choice here, as a simple, modular "NoSQL" database, it's fast, easy to work with, and offers affordable storage plans.                </p>
                <p>
                This database uses a format similar to JSON (BSON) files to store data, with a dense collection of query modules, with the aggregation module allowing you to create your own query, extracting only the exact information formatted the way i need on the front end.

                </p>
                <p>
                One problem with your approach, is about organization and sizing, it turns out that the best feature of this database could be considered a disadvantage, the lack of restrictions makes it very difficult to scale this database, it is also difficult to make relations between data fields, is it possible, but that's not what this database was made for.

                </p>
            </div>

            <div className={styles.stackSection} id='stacks-mern-api'>
                <label> API gateway</label>
                <p>
                This is a layer that is on the server side, responsible for connecting the user (client) to the server, everything external to the website, such as storing customer data, will be managed by a server through an API (in this method , others like containers and microservices use more complex structures).

                </p>
                <p>
                Express.js is the standard for creating a server side with JavaScript, it will handle all the normal request/response operations.
                </p>
                <p>
                It is easily integrable with all kinds of other packages, normally middleware (code that precedes any response) is used to configure the packages that are on the server side
                </p>
               
            </div>

            <div className={styles.stackSection} id ='stacks-mern-auth'>
                <label> Authentication</label>
                <p>
                To connect the client to the server, it is necessary to perform some type of user authentication, for security and performance reasons. Authenticating a user against a database belonging to the project is the best way to guarantee a secure connection.
                </p>
                <p>
                For this I prefer to use a package called passport.js, very modular, with several client authentication options, certified by most web services such as Google, Facebook and GitHub.
                </p>
                <p>
                Normally the user session is connected by a session cookie, shared between the server and the client, it is possible to decide what information is needed by the client, through a customized database, hosted by the project, or just use a microservice. third-party authentication, such as Google oAuth, which allows the user to log in to the project through a Google account, as long as the user authorizes the sharing of data with their Google account and the website requesting it.
                </p>
            </div>

            <div className={styles.stackSection} id ='stacks-mern-others'>
                <label>Other Packages</label>
                <p>
                For other operations, the vast set of packages presented in the node.js environment is used.
                </p>
                <p>
                Packages can be used to access the client file system with the grid fs package, create and download documents like the pupettear package, which also allows web crowling and other web scrapping operations.
                </p>
            </div>

            <div className={styles.stackSection} id ='stacks-mern-deployment'>
                <label> Deployment</label>
                <p>
                With this stack, two deployments are typically used, separating the front and back-end; in some cases, back-end operations can be performed by the deployment service used.
                </p>
                <p>
                Options can vary from serverless functions to virtual machine servers and cloud managed solutions. Each have their own characteristics, performance and other parameters can help to decide what architecture runs.
                </p>
                <p>
                I normally use netlifly for my front-end, for projects with pure React, without much back-end complexity, the form handler available through the platform helps to deal with some operations.                
                </p>
                <p>
                Servers to handle the backend usually run on platforms like Render, allowing users to configure the amount of resources used and also providing 24/7 access to the service, unlike serverless functions, which feature some issues related to time without activity.
                </p>
            
            </div>

          

            <div className={styles.stackInfo}>
                <h3 id='stacks-t3'> T3 Stack </h3>
                <p>
                    This is the most advanced stack, delivering the best development experience with a minimal set of tools.
                </p>
            </div>

            <div className={styles.stackSection} id ='stacks-t3-db'>
                <label> Database</label>
                <p>
                Here we use some technologies that are more aligned with industry standards, opting for relational databases that have been around for some time.
                </p>
                <p>
                PostGres SQL is a relational database, similar to SQL, MySQL and SQL Lite, using almost the same syntaxes. This is a powerful database, very well organized, with a good number of options to impose restrictions on the dataset, facilitating the creation of relationships between data tables.
                </p>
                <p>
                For a better development experience, we generally use an ORM, in this case, some type of system that connects the database with operations written in javaScript/TypeScript, facilitating the process of creating schemas, relationships and queries by the developer.
                </p>
                <p>
                Orms like prima, drizzle and neon can be used to maximize the development phase, it is also possible to handle direct SQL code which is handled by many available drivers to interact with the database without an orm.
                </p>
            </div>
            <div className={styles.stackSection} id ='stacks-t3-api'>
                <label> API Gateway</label>
                <p>
                With this type of technology, it is preferable to use the Next.js API route for a better development experience.
                </p>
                <p>
                When using API routes, the server side of your applications is created within the same project as the client side, this opens up all kinds of possibilities, facilitating the use of server components and other functionalities.
                </p>
                <p>
                This type of technology is always changing, new features are delivered with each update, this guarantees constant growth, with new improvements, features and more possibilities of use, but this can also be bad, it means that developers will be working with cutting-edge technologies, even those that claim improvements over older methods, new bugs can be found when using newer versions.
                </p>
            </div>
            <div className={styles.stackSection} id ='stacks-t3-auth'>
                <label> Authentication</label>
                <p>
                One of the best available packages with this stack is NextAuth (future AuthJs), the extensive use of JWTs (JSON web tokens) and cookies make this one of the best available technologies out there.
                </p>
                <p>
                Their usage is similar to other authentication packages, they also have certifications with third-party authentication systems like google oAuth, but with the addition of being written mostly in TypeScrypt, ensuring type-safe development, avoiding data and performance loss. .
                </p>
                <p>
                It can be integrated with server components for an easy development process, eliminating some of the need for API routes to handle the database, although it is preferable to separate this function from the API router.
                </p>
            </div>
            <div className={styles.stackSection} id ='stacks-t3-others'>
                <label> Other Packages</label>
                <p>
                Here again we can use the node.js environment to add packages to projects, with this more modern state it is easy to adapt some frameworks that run on top of Next.js, such as tailwind, bootstrap and framer-motion, all of these are front-end frameworks. end that help in the development phase.
                </p>
                <p>
                Other popular packages here are state management, because server-side components are defined by default after Next 13, we still use client components (explicitly declared), in them we can track our react states using packages like zustand, redux and reactQuery all allow the developer to store data on the client side.
                </p>
                <p>
                Some packages also improve performance, like reactQuery, a package that enforces a new way of fetching data on the client side, allowing us to store the data until it changes, then we can use the server side again to get the new data , avoiding unnecessary use. of resources for the application.
                </p>
                <p>
                For email operations, i generally rely on packages supported by nodemailer, such as mailgun and ReSend.
                </p>
            </div>

            
            <div className={styles.stackSection} id ='stacks-t3-deployment'>
                <label > Deployment </label>

                <p>
                With this stack, options are generally tied to serverless functions architecture, they are fast, extremely cost-effective, but they have some drawbacks.
                </p>

                <p>
                One of the disadvantages is the cold boot start, an inevitable problem that serverless functions have (it usually happens on the first request and between periods of inactivity), the function takes some time to be activated on the server, creating some time without response to the client. 
                In many cases the impact is minimal and can be managed by other strategies that act in accordance with the project deployed.
                </p>

                <p>
                The deployment options here are vast, I have more experience with vercel and netlify platforms to deploy and manage the products.
                </p>

            </div>


       
    </div>
  )
}

export default StacksContent